export default "__VITE_ASSET__4_xa9UcO__"